

interface StepCardProps {
    stepCount: string
    stepHeading: string
    stepDescription: string
}

export const Stepcard: React.FC<StepCardProps> = ({ stepCount, stepHeading, stepDescription }): JSX.Element => {
    return (
        <div className="step-card">
            <div className="step-count-wrapper">{stepCount}</div>
            <div className="step-heading">{stepHeading}</div>
            <div className="step-description">{stepDescription}</div>
        </div>
    )
}

export default Stepcard